import services from './../../../services/service'; // Service Class
import validation from './../../../services/validation'; // Validation
import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer

let service = new services();
let validator = new validation();
export default {
    name: 'DashboardTemplate',
    data () {
        return {
            loading:false,
           
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
     },
    methods: {
        
    },
}


// WEBPACK FOOTER //
// ./src/pages/Dashboard/TemplateDashboard/script.js